export default {
  state: {
    visibility: false
  },
  mutations: {
    SET_TICKET_CARD_VISIBILITY(state, payload) {
      state.visibility = payload
    }
  }
}
